import React from "react";
export const useTranslationHook = labels => {
  const [resourceBundle, setResourceBundle] = React.useState(labels);
  React.useEffect(() => {
    setResourceBundle(labels);
  }, [labels]);
  const t = (key, ...args) => {
    let translatedValue;
    //this should never be the case, but check to see if we have a resource bundle
    if (!resourceBundle) {
      translatedValue = key;
    } else {
      translatedValue = resourceBundle[key] ? resourceBundle[key] : key;
    }
    if (args.length > 0) {
      translatedValue = replacePlaceholders(translatedValue, args);
      return translatedValue;
    }
    return translatedValue;
  };
  const replacePlaceholders = (translatedValue, values) => {
    try {
      let index = -1;
      return values.reduce((previous, value) => {
        index++;
        return previous.replace(`{${index}}`, value);
      }, translatedValue);
    } catch (error) {
      return translatedValue;
    }
  };
  return {
    t,
    setResourceBundle,
    resourceBundle
  };
};